import React, { useState, useRef, useEffect } from 'react';
import { motion, AnimatePresence } from "framer-motion";
import '../pages/css/Home.css';
import '../pages/css/ProductPageUpdated.css';
import banner from '../images/hrias-banner.jpg';
import dashboard from '../images/dash.gif';
import servicebg from '../images/testimonial-bg.png';
import {
    FaLaptopCode,
    FaBrain,
    FaGreaterThan,
    FaLessThan,
    FaPlay,
    FaTimesCircle,
    FaCheckCircle,
    FaArrowLeft,
    FaArrowRight
} from 'react-icons/fa';
import { GiRobotAntennas } from 'react-icons/gi';
import { MdOutlineRocketLaunch } from 'react-icons/md';
import customDev from '../images/dm6.png';
import intentSignal from '../images/dm5.png';
import dm6 from '../images/dm7.png';
import multiChannel from '../images/dm4.png';
import notSpam from '../images/d5.png';
import aiPersonalization from '../images/dm3.png';
import prospects from '../images/dm2.png';
import multiChannelOutreach from '../images/leads-engine.png';
import marketing2 from '../images/nexora-testimonial.png';
import marketing3 from '../images/Client-Testimonial-Nexora.mp4';
import marketing4 from '../images/marketing4.svg';
import ct1 from '../images/ct1.jpg';
import ct2 from '../images/ct5.jpg';
import ct3 from '../images/ct2.jpg';
import ct4 from '../images/ct7.jpg';
import cTOne from '../images/kpmg.png';
import cTTwo from '../images/deloite.png';
import cTThree from '../images/berkshire.png';
import cTFive from '../images/pwc.jpg';
import cTSix from '../images/microsoft.png';
import cTSeven from '../images/JPMorgan.png';
import cTEight from '../images/Goldman.jpg';
import review6 from '../images/review6.jpg';
import cTFour from '../images/Google.png';
import cTNine from '../images/spg-logo1.png';
import cTTen from '../images/sociazy-logo1.png';
import cTEleven from '../images/tobor-logo.jpg';
import cTTwelve from '../images/nervana-logo1.png';
import cTthirteen from '../images/p-edits1.png';
import cTFourteen from '../images/bluebox3.png';
import cTS51 from '../images/S51logo1.png';
import cTPakka from '../images/pakka.png';
import { Container, Row, Col, Button } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import { FaRegCheckCircle } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";

function ProductPage() {

    const navigate = useNavigate();

    useEffect(() => {
        const hash = window.location.hash;

        if (hash) {
            const element = document.querySelector(hash);

            if (element) {
                setTimeout(() => {
                    element.scrollIntoView({
                        behavior: "smooth",
                        block: "start"
                    });
                }, 300);
            }
        }
    }, []);

    const iconStyle = {
        backgroundColor: "#28a745",
        color: "#fff",
        borderRadius: "50%",
        padding: "4px",
        marginRight: "8px",
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: "12px",
    };

    const faqColumn1 = [
        {
            question: "What exactly do you do?",
            answer:
                "We handle your entire outbound — from identifying the right prospects to reaching out, managing conversations, qualifying them, and booking meetings directly into your calendar. You only step in when it’s time to close."
        },
        {
            question: "Is this lead generation or appointment setting?",
            answer:
                "Both. We don’t stop at giving you a list of leads — we turn those leads into actual booked meetings with people who are relevant and interested."
        },
        {
            question: "How do you ensure the meetings are qualified?",
            answer:
                "Every prospect goes through filtering before a meeting is booked. We target based on your ICP, start real conversations, and only schedule calls when there’s clear intent or a relevant need."
        },
        {
            question: "Who are the people I’ll be speaking with?",
            answer:
                "Decision-makers or relevant stakeholders who match your target audience and have a potential need for your service — not random or mismatched prospects."
        },
        {
            question: "Which channels do you use for outreach?",
            answer:
                "Primarily LinkedIn and email, sometimes combined depending on your market. The goal is to reach your prospects where they are most active and responsive."
        },
        {
            question: "Will this work for my business?",
            answer:
                "This works best for B2B and high-ticket B2C services where there’s a clear target audience, your offer solves a real problem, and a sales conversation is needed before closing. If that’s you, this fits."
        },
        {
            question: "How long does it take to see results?",
            answer:
                "Outbound is a system, not a one-day campaign. Initial traction typically starts within the first few weeks, with consistent meetings building as campaigns optimize."
        },
        {
            question: "Do you use templates or custom messaging?",
            answer:
                "Everything is customized. Your positioning, audience, and offer are different — your messaging should be too."
        }
    ];

    const faqColumn2 = [
        {
            question: "Do you just send messages, or handle replies too?",
            answer:
                "We handle the full conversation flow — including replies, follow-ups, and qualification — until a meeting is ready to be booked."
        },
        {
            question: "How are meetings scheduled?",
            answer:
                "We directly book meetings into your calendar based on your availability, making the process seamless for you."
        },
        {
            question: "What kind of reporting do I get?",
            answer:
                "You’ll see clear performance metrics — outreach, responses, conversations, and meetings booked — along with ongoing improvements."
        },
        {
            question: "How is this different from hiring an in-house SDR?",
            answer:
                "No hiring, training, or management needed. You get a ready system, experienced execution, and faster ramp-up without the overhead."
        },
        {
            question: "Do you guarantee results?",
            answer:
                "No serious outbound partner guarantees unrealistic numbers. What we do guarantee is a structured system, consistent execution, and continuous optimization focused on generating real conversations."
        },
        {
            question: "What do you need from me to get started?",
            answer:
                "Clarity on your offer, a basic understanding of your target audience, and access to your calendar for scheduling. We handle the rest."
        },
        {
            question: "What happens after a meeting is booked?",
            answer:
                "You take over. The prospect shows up to the call — your job is to convert them into a client."
        },
        {
            question: "Can you scale campaigns once they start working?",
            answer:
                "Yes. Once we identify winning messaging and audience segments, we scale outreach volume, expand targeting, and optimize performance to increase consistent meeting flow without compromising quality."
        }
    ];

    const fadeInUp = {
        hidden: { opacity: 0, y: 50 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.6,
                ease: 'easeOut'
            }
        },
    };

    const openVideoPopup = () => {
        Swal.fire({
            html: `
                <div style="width:100%;height:100%;margin:0;padding:0;">
                    <video
                        src="${marketing3}"
                        controls
                        autoplay
                        playsinline
                        style="
                            width:100%;
                            height:100%;
                            object-fit:contain;
                            background:#000;
                            display:block;
                            border-radius:10px;
                        "
                    ></video>
                </div>
            `,
            background: "#111",
            width: "80%",
            padding: 0,
            heightAuto: false,
            showConfirmButton: false,
            showCloseButton: true,
            customClass: {
                popup: "video-popup-style"
            },
            didOpen: (popup) => {
                popup.style.height = "80vh";
                popup.style.padding = "0";

                popup.querySelector(".swal2-html-container").style.margin = "0";
                popup.querySelector(".swal2-html-container").style.padding = "0";
                popup.querySelector(".swal2-html-container").style.height = "100%";
            }
        });
    };

    const scrollRef = useRef(null);

    const scrollLeft = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({
                left: -300,
                behavior: 'smooth'
            });
        }
    };

    const scrollRight = () => {
        if (scrollRef.current) {
            scrollRef.current.scrollBy({
                left: 300,
                behavior: 'smooth'
            });
        }
    };

    const [currentSection, setCurrentSection] = useState(0);

    const sections = [
        {
            title: "PACCA",

            description:
                "PACCA is an unlimited design, web development, and custom software development agency helping growing companies build stronger brands, digital experiences, and technology solutions.",

            feature1Title: "187% More Profile Views",

            feature1Desc:
                "Increased Tiago Rosado's LinkedIn profile visibility by 187% within just 30 days through ICP-led positioning and founder-focused content.",

            feature2Title: "12 Qualified Opportunities",

            feature2Desc:
                "Generated 12 qualified business opportunities by combining authority-led content, profile optimization, and human-led LinkedIn outbound.",

            details: `
How We Turned an Agency Founder’s LinkedIn Into a Demand-Generation Channel

Tiago Rosado — Founder, PACCA

Industry:
Branding, Web Design & Development, Custom Software Development

Service:
ICP + Offer Refinement, Positioning, Human-Led Outbound + Inbound System

Timeline:
30 Days


The Challenge

Tiago Rosado had the expertise, experience, and a strong design business. But his LinkedIn presence wasn't generating enough attention, authority, or opportunities for the level of business he was building.

He didn't need another generic content strategy.

He needed LinkedIn to become a business development asset capable of creating visibility, building trust, and generating qualified opportunities for PACCA.


The Strategy

We rebuilt Tiago's LinkedIn presence around one goal:

Make the right prospects understand why Tiago and PACCA were the right strategic partner for their brand.


We focused on:

• ICP-led positioning — Speaking directly to companies that had outgrown their existing brand and needed stronger digital positioning.

• Authority content — Turning Tiago's 14+ years of design experience into valuable insights that demonstrated expertise and built credibility.

• Founder-led storytelling — Making the person behind PACCA visible, authentic, and memorable.

• Strategic content — Creating content designed to build trust and demand rather than chasing vanity engagement.

• Profile optimisation — Transforming Tiago's LinkedIn profile into a clear positioning and conversion asset for potential clients.

• Human-led outbound — Running targeted LinkedIn outreach based on relevant buying signals, reaching the right prospects at the right time instead of relying on spammy cold lists.


The Result

Instead of treating LinkedIn as a place to simply "post content," we positioned it as an organic acquisition channel for PACCA.

The result was a stronger founder brand, clearer positioning, and a LinkedIn presence that worked as an extension of the business.

Tiago went from being another agency founder on LinkedIn to building recognition around his expertise, his point of view, and what PACCA stands for.


The ROI

The real value wasn't follower count.

It was creating an asset that compounds:

More visibility → More credibility → More qualified conversations → More opportunities for PACCA.

And because every piece of content was built around Tiago's ICP and offer, the audience being built wasn't just an audience.

It was an audience of potential buyers.


Key Results

• +187% Profile Views in 30 Days
• 3.4× More Engagement
• 12 Qualified Opportunities
• Stronger Founder-Led Brand Positioning
• LinkedIn transformed into an organic demand-generation channel


The Outcome

We didn't help Tiago "post more."

We helped turn his expertise into a LinkedIn asset that can continuously create demand for PACCA.

Expertise → Authority → Attention → Conversations → Revenue.
`,

            image: cTPakka
        },

        {
            title: "Blue Box Media",

            description:
                "Blue Box Media is an influencer marketing agency executing performance-driven campaigns for leading consumer brands.",

            feature1Title: "96+ Brand Conversations",

            feature1Desc:
                "Generated qualified conversations with enterprise and high-growth D2C brands in just 45 days.",

            feature2Title: "27 Sales Meetings",

            feature2Desc:
                "Booked meetings directly with high-value brands and key decision-makers.",

            details: `
Company Overview

Blue Box Media is an influencer marketing agency executing performance-driven campaigns for leading consumer brands.

Objective

Establish a direct pipeline to enterprise and high-growth D2C brands without relying on referrals.

Challenge

• Strong portfolio but weak distribution
• No outbound system
• No consistent deal flow
• No direct access to brand decision-makers

Strategy

1. Account-Based Targeting

Built a curated pipeline of marketing heads and brand leaders across beauty, FMCG, and D2C sectors.

2. High-Leverage Outreach

Executed personalized outbound campaigns designed to start conversations instead of pitching services.

3. Authority Amplification

Positioned Blue Box Media through past brand success stories to instantly establish credibility.

4. Conversion Optimization

Continuously refined messaging based on actual conversion data to maximize booked meetings.

Results

• 96+ qualified brand conversations in 45 days
• 27 meetings with high-value brands
• 21% positive reply rate
• Direct access to enterprise decision-makers

Conclusion

Blue Box Media transitioned from referral-dependent growth to a scalable outbound acquisition system with predictable deal flow.
`,

            image: cTFourteen
        },

        {
            title: "Sociazy",

            description:
                "Sociazy is a digital transformation and IT solutions company serving global clients across SaaS, eCommerce, and enterprise segments.",

            feature1Title: "147+ Conversations",

            feature1Desc:
                "Generated qualified conversations with founders, CTOs, and product leaders across North America and Europe.",

            feature2Title: "$3.2M+ Pipeline",

            feature2Desc:
                "Created a high-value sales pipeline while consistently booking qualified opportunities.",

            details: `
Company Overview

Sociazy is a digital transformation and IT solutions company serving global clients across SaaS, eCommerce, and enterprise segments.

Objective

Build a predictable, high-value outbound pipeline capable of consistently generating qualified opportunities with global decision-makers.

Challenge

• Sociazy had the technical depth but lacked distribution
• No structured outbound
• No defined ICP
• No consistent pipeline
• Growth was opportunistic, not engineered

Strategy

1. Precision Targeting

We identified and segmented high-value accounts across North America and Europe — founders, CTOs, and product leaders actively investing in technology.

2. Outbound Infrastructure

Deployed a multi-channel outbound system across email and LinkedIn designed to initiate high-context conversations at scale.

3. Market-Aligned Positioning

Reframed Sociazy’s offering around execution speed, scalability, and reliability — the factors technical buyers actually respond to.

4. Pipeline Engineering

Optimized every campaign around one metric: qualified pipeline generated, not vanity engagement.

Results

• 147+ qualified conversations in 60 days
• 38 high-intent sales meetings booked
• $3.2M+ pipeline generated
• 18% average reply rate

Conclusion

Sociazy moved from unpredictable inbound to a controlled outbound engine capable of generating consistent, high-value opportunities on demand.
`,

            image: cTTen
        },

        {
            title: "Pinnacle Edits",

            description:
                "Pinnacle Edits is a global photo and video post-production partner helping photographers, studios, agencies, and brands scale content production without expanding internal editing teams.",

            feature1Title: "214+ Conversations",

            feature1Desc:
                "Generated qualified conversations with photography studios, agencies, eCommerce brands, and production companies worldwide.",

            feature2Title: "$4.1M+ Pipeline Influenced",

            feature2Desc:
                "Created enterprise opportunities and high-value sales conversations across global markets.",

            details: `
Company Overview

Pinnacle Edits is a global photo and video post-production partner helping photographers, studios, agencies, and brands scale content production without expanding internal editing teams.

With over 1,200 clients worldwide, 6M+ images delivered, and a reputation for rapid turnaround, the company serves businesses across the United States, United Kingdom, Canada, Australia, UAE, and beyond.

Objective

Build a predictable outbound acquisition engine capable of generating conversations with photography studios, creative agencies, eCommerce brands, and high-volume content production companies globally.

Challenge

• Operational excellence but limited distribution
• Growth dependent on referrals and inbound inquiries
• Needed direct access to decision-makers
• No scalable outbound acquisition engine
• Required predictable pipeline generation

Strategy

1. Global Market Segmentation

Identified and segmented high-value accounts across photography studios, production companies, marketing agencies, eCommerce brands, and real estate media companies.

Focused exclusively on organizations with recurring editing requirements and long-term outsourcing potential.

2. Authority-Led Positioning

Positioned Pinnacle Edits as a post-production growth partner rather than another editing vendor.

Messaging highlighted:

• 6M+ images delivered
• 24-hour turnaround capability
• Dedicated editing teams
• Enterprise-grade security and workflow management
• Global delivery experience

3. Multi-Channel Outbound Execution

Deployed a structured outbound system across LinkedIn and email targeting:

• Photography studio owners
• Agency founders
• Creative directors
• Production managers
• eCommerce operations leaders

The focus was creating qualified sales conversations with organizations already facing content production bottlenecks.

4. Pipeline Optimization

Continuously optimized campaigns based on:

• Positive reply rates
• Sales conversations booked
• Qualified opportunities generated
• Pipeline value created

Every optimization decision was directly tied to revenue outcomes.

Results

• 214+ qualified conversations generated
• 63 discovery calls booked with decision-makers
• 29 enterprise opportunities created
• $4.1M+ pipeline influenced
• 24% positive reply rate
• New opportunities opened across North America, Europe, and Australia

Conclusion

Pinnacle Edits transformed outbound from an inconsistent growth channel into a repeatable client acquisition system.

By combining authority-led positioning, precise targeting, and a structured outbound process, the company established a predictable pipeline of high-value opportunities while expanding its reach into new international markets.
`,

            image: cTthirteen
        },

        {
            title: "Strategy Power Group",

            description:
                "Strategy Power Group is a business consulting firm specializing in international market expansion for companies in the healthcare supplements and personal care sectors.",

            feature1Title: "121+ Qualified Conversations",

            feature1Desc:
                "Generated high-intent conversations with founders, export heads, and international business leaders across global markets.",

            feature2Title: "$2.7M+ Pipeline Generated",

            feature2Desc:
                "Created enterprise expansion opportunities and strategic growth conversations across multiple international regions.",

            details: `
Company Overview

Strategy Power Group is a business consulting firm specializing in international market expansion for companies in the healthcare supplements and personal care sectors.

With over 20 years of combined expertise, the firm supports brands in entering new geographies, navigating regulatory landscapes, and scaling global operations.

Objective

Build a consistent pipeline of international business opportunities by connecting with founders, export heads, and decision-makers actively looking to expand into global markets.

Challenge

• Deep industry expertise but limited scalable access
• Growth primarily dependent on referrals and existing networks
• No structured outbound acquisition system
• Limited visibility across international markets
• Inconsistent deal flow
• Difficulty reaching decision-makers at scale

Strategy

1. Global Market Targeting

Mapped high-intent markets across the US, UK, Middle East, and Southeast Asia where demand for healthcare supplements and personal care products continues to grow.

Target personas included:

• Founders and CEOs
• Export and International Business Heads
• Category Leaders in Supplements and Personal Care

2. Authority-Led Positioning

Positioned Strategy Power Group as a specialist international expansion partner rather than a generic consulting firm.

Messaging emphasized:

• 20+ years of category expertise
• Deep regulatory and compliance knowledge
• Proven international market expansion capabilities

3. Multi-Channel Outbound Execution

Implemented a structured outbound system across LinkedIn and email to create high-value conversations with decision-makers actively exploring international growth opportunities.

The focus was relevance and intent rather than volume.

4. Pipeline Systemization

Built a scalable framework to:

• Capture inbound responses
• Qualify opportunities
• Track deal progression
• Maintain consistent follow-up sequences

Every interaction was designed to advance prospects toward strategic business discussions.

Results

• 34 high-value international strategy calls booked
• 121+ qualified conversations across target markets
• 17 enterprise expansion opportunities created
• $2.7M+ pipeline generated
• 19% positive reply rate

Conclusion

Strategy Power Group transitioned from relationship-driven growth to a scalable international acquisition engine.

Outbound became a predictable channel for generating high-intent conversations with global decision-makers, unlocking consistent expansion opportunities across multiple markets.
`,

            image: cTNine
        },

        {
            title: "S51 Agency",

            description:
                "S51 Agency is a creative and digital marketing agency helping brands build stronger visibility, customer engagement, and growth through strategic digital solutions.",

            feature1Title: "53 Sales Meetings",

            feature1Desc:
                "Booked qualified meetings with founders, marketing leaders, and decision-makers across targeted industries.",

            feature2Title: "3,687+ Prospects Reached",

            feature2Desc:
                "Built a targeted prospect pipeline and executed structured outbound campaigns across LinkedIn and email.",

            details: `
Company Overview

S51 Agency is a creative and digital marketing agency helping brands strengthen their digital presence, reach new audiences, and accelerate business growth through strategic marketing solutions.

Objective

Build a predictable client acquisition system capable of consistently generating qualified conversations and sales opportunities with brands actively looking for digital marketing and creative services.

Challenge

• Strong service capabilities but inconsistent lead flow
• Heavy dependence on referrals and existing networks
• No structured outbound acquisition system
• Difficulty reaching relevant decision-makers directly
• Limited visibility into the sales pipeline
• Inconsistent meeting generation

Strategy

Targeted Prospect Research

Built highly targeted prospect lists based on S51 Agency's ideal customer profile.

Focused on founders, CEOs, marketing heads, brand managers, and decision-makers within companies actively investing in digital marketing and customer acquisition.

Multi-Channel Outreach

Deployed structured outbound campaigns across LinkedIn and email to create direct conversations with relevant prospects.

Messaging was personalized around the prospect's business, current digital presence, and potential growth opportunities rather than using generic agency pitches.

Lead Qualification

Implemented a structured qualification process to identify prospects with genuine business requirements, active marketing initiatives, and potential fit for S51 Agency's services.

The focus was on generating qualified opportunities rather than simply increasing lead volume.

Meeting Generation & Pipeline Development

Optimized outreach campaigns around meaningful sales conversations and booked meetings.

Campaign performance was continuously monitored and refined based on response rates, engagement, meeting bookings, and opportunity quality.

Results

• 3,687+ targeted prospects contacted
• 9,842+ emails sent
• 53 qualified sales meetings booked
• 29% increase in prospects contacted
• 32% increase in outreach activity
• 48% increase in meetings booked
• Consistent flow of qualified opportunities

Conclusion

S51 Agency transformed its outbound process from an inconsistent lead generation activity into a structured client acquisition system.

By combining targeted prospect research, personalized LinkedIn and email outreach, lead qualification, and systematic follow-up, Peregrinee helped S51 Agency create a more predictable flow of qualified sales conversations and new business opportunities.
`,

            image: cTS51
        }
    ];

    /*
    ============================================================
    VIEW MORE POPUP
    ============================================================
    */

    const handleViewMore = () => {

        let content = sections[currentSection].details;

        /*
        Main section headings
        These are converted into proper block-level headings
        with bold text, different color and spacing.
        */

        const headings = [
            "Company Overview",
            "Objective",
            "Challenge",
            "Strategy",
            "Results",
            "Conclusion",
            "The Challenge",
            "The Strategy",
            "The Result",
            "The ROI",
            "Key Results",
            "The Outcome"
        ];

        headings.forEach((heading) => {

            const escapedHeading = heading.replace(
                /[.*+?^${}()|[\]\\]/g,
                "\\$&"
            );

            content = content.replace(
                new RegExp(`(^|\\n)${escapedHeading}(?=\\n|$)`, "g"),
                `$1
                    <div class="case-study-heading">
                        ${heading}
                    </div>
                `
            );
        });

        /*
        Strategy numbered headings
        Example:
        1. Account-Based Targeting
        2. High-Leverage Outreach
        */

        content = content.replace(
            /(^|\n)(\d+\.\s+[^\n]+)(?=\n)/g,
            `$1
                <div class="case-study-subheading">
                    $2
                </div>
            `
        );

        /*
        Convert bullet points into styled bullets.
        */

        content = content.replace(
            /(^|\n)•\s*([^\n]+)/g,
            `$1
                <div class="case-study-bullet">
                    <span class="case-study-bullet-icon">•</span>
                    <span>$2</span>
                </div>
            `
        );

        /*
        Convert remaining line breaks.
        */

        content = content
            .replace(/\n{2,}/g, "<div class='case-study-space'></div>")
            .replace(/\n/g, "<br>");

        Swal.fire({

            title: sections[currentSection].title,

            html: `
                <div class="case-study-popup-content">
                    ${content}
                </div>
            `,

            width: "850px",

            background: "#e7f3ff",

            color: "#374151",

            showConfirmButton: false,

            showCloseButton: true,

            customClass: {
                popup: "custom-case-study-popup",
                title: "custom-case-study-title",
                closeButton: "custom-case-study-close"
            },

            didOpen: () => {

                /*
                Add popup-specific styles dynamically so
                everything works without changing your CSS file.
                */

                const style = document.createElement("style");

                style.id = "case-study-popup-styles";

                style.innerHTML = `

                    .custom-case-study-popup {
                        border-radius: 20px !important;
                        border: 2px solid #0D6EFD !important;
                        box-shadow: 0 20px 50px rgba(0,0,0,0.20) !important;
                    }

                    .custom-case-study-title {
                        color: #0D6EFD !important;
                        font-family: Poppins, sans-serif !important;
                        font-size: 28px !important;
                        font-weight: 800 !important;
                        margin-bottom: 5px !important;
                    }

                    .custom-case-study-close {
                        color: #0D6EFD !important;
                        font-size: 28px !important;
                        font-weight: 700 !important;
                    }

                    .case-study-popup-content {
                        text-align: left;
                        font-family: Poppins, sans-serif;
                        font-size: 14px;
                        line-height: 1.7;
                        color: #4B5563;
                        max-height: 500px;
                        overflow-y: auto;
                        padding: 8px 14px 15px 14px;
                        scrollbar-width: thin;
                        scrollbar-color: #0D6EFD #dceeff;
                    }

                    .case-study-popup-content::-webkit-scrollbar {
                        width: 7px;
                    }

                    .case-study-popup-content::-webkit-scrollbar-track {
                        background: #dceeff;
                        border-radius: 10px;
                    }

                    .case-study-popup-content::-webkit-scrollbar-thumb {
                        background: #0D6EFD;
                        border-radius: 10px;
                    }

                    /*
                    Main popup headings
                    */

                    .case-study-heading {
                        display: block;
                        color: #0D6EFD;
                        font-size: 21px;
                        font-weight: 800;
                        line-height: 1.3;
                        margin-top: 22px;
                        margin-bottom: 9px;
                        padding-bottom: 5px;
                        border-bottom: 2px solid rgba(13, 110, 253, 0.18);
                    }

                    /*
                    Numbered strategy headings
                    */

                    .case-study-subheading {
                        display: block;
                        color: #6610F2;
                        font-size: 16px;
                        font-weight: 800;
                        line-height: 1.4;
                        margin-top: 14px;
                        margin-bottom: 5px;
                    }

                    /*
                    Bullet points
                    */

                    .case-study-bullet {
                        display: flex;
                        align-items: flex-start;
                        gap: 7px;
                        margin: 5px 0;
                        padding-left: 3px;
                    }

                    .case-study-bullet-icon {
                        color: #0D6EFD;
                        font-size: 18px;
                        font-weight: 900;
                        line-height: 1.4;
                        flex-shrink: 0;
                    }

                    /*
                    Spacing between paragraphs
                    */

                    .case-study-space {
                        height: 7px;
                    }

                    /*
                    Mobile responsive popup
                    */

                    @media (max-width: 768px) {

                        .custom-case-study-popup {
                            width: 94% !important;
                            padding: 15px !important;
                        }

                        .custom-case-study-title {
                            font-size: 23px !important;
                        }

                        .case-study-popup-content {
                            font-size: 13px;
                            line-height: 1.65;
                            max-height: 70vh;
                            padding: 5px 7px 10px 7px;
                        }

                        .case-study-heading {
                            font-size: 18px;
                            margin-top: 18px;
                        }

                        .case-study-subheading {
                            font-size: 15px;
                        }
                    }

                `;

                /*
                Prevent duplicate style injection.
                */

                const existingStyle = document.getElementById(
                    "case-study-popup-styles"
                );

                if (existingStyle) {
                    existingStyle.remove();
                }

                document.head.appendChild(style);
            },

            willClose: () => {

                const existingStyle = document.getElementById(
                    "case-study-popup-styles"
                );

                if (existingStyle) {
                    existingStyle.remove();
                }

            }
        });
    };

    return (
        <>
            <section className="product-section-2">
                <Container>
                    <Row className="justify-content-center">
                        <Col lg={12} className="text-center">

                            <h1
                                className="product-heading fw-bold mb-3"
                                style={{
                                    fontFamily: 'Poppins, sans-serif',
                                    fontSize: '2.7rem',
                                    lineHeight: '1.4',
                                }}
                            >
                                <span style={{ color: '#0d6efd' }}>
                                    Peregrinee
                                </span>{' '}
                                is the world’s number 1{' '}
                                <span style={{ color: '#6610f2' }}>
                                    outbound growth partner
                                </span>{' '}
                                for{' '}
                                <span style={{ color: '#0d6efd' }}>
                                    B2B companies
                                </span>{' '}
                                looking to turn outbound into a{' '}
                                <span style={{ color: '#6610f2' }}>
                                    predictable lead generation channel.
                                </span>
                            </h1>

                            <p
                                className="product-subheading text-muted"
                                style={{
                                    fontFamily: 'Poppins, sans-serif',
                                    fontSize: '1.05rem',
                                    lineHeight: '1.8',
                                    fontWeight: '800',
                                }}
                            >
                                We deliver{' '}
                                <span style={{ color: '#0d6efd' }}>
                                    guaranteed sales-qualified leads
                                </span>{' '}
                                booked directly on your{' '}
                                <span style={{ color: '#198754' }}>
                                    sales calendar
                                </span>.{' '}
                                <span style={{ color: '#fd7e14' }}>
                                    100% Done-For-You
                                </span>. So you can finally scale with{' '}
                                <span style={{ color: '#dc3545' }}>
                                    predictable revenue growth
                                </span>.
                            </p>

                            <motion.div>

                                <Button
                                    className="product-btn"
                                    onClick={() => navigate("/contact-us")}
                                >
                                    Book a Call
                                </Button>

                                <Button
                                    className="ms-3"
                                    onClick={() => {
                                        document
                                            .getElementById("case-studies")
                                            ?.scrollIntoView({
                                                behavior: "smooth",
                                                block: "start"
                                            });
                                    }}
                                    style={{
                                        background: "transparent",
                                        border: "2px solid #0d6efd",
                                        color: "#0d6efd",
                                        padding: "10px 24px",
                                        fontWeight: 600,
                                        borderRadius: "8px"
                                    }}
                                >
                                    View Case Studies
                                </Button>

                            </motion.div>

                            <div className="container mt-4">

                                <div className="row text-center">

                                    <div className="col-md-3 col-6 mb-3">
                                        <div className="stat-box p-3 shadow-sm rounded">
                                            <h2
                                                className="fw-bold mb-1"
                                                style={{ color: '#0d6efd' }}
                                            >
                                                $10.4M+
                                            </h2>

                                            <p className="mb-0 fw-semibold text-muted small">
                                                Pipeline Generated
                                            </p>
                                        </div>
                                    </div>

                                    <div className="col-md-3 col-6 mb-3">
                                        <div className="stat-box p-3 shadow-sm rounded">
                                            <h2
                                                className="fw-bold mb-1"
                                                style={{ color: '#6610f2' }}
                                            >
                                                12k+
                                            </h2>

                                            <p className="mb-0 fw-semibold text-muted small">
                                                Meetings Booked
                                            </p>
                                        </div>
                                    </div>

                                    <div className="col-md-3 col-6 mb-3">
                                        <div className="stat-box p-3 shadow-sm rounded">
                                            <h2
                                                className="fw-bold mb-1"
                                                style={{ color: '#198754' }}
                                            >
                                                85K+
                                            </h2>

                                            <p className="mb-0 fw-semibold text-muted small">
                                                Prospects Contacted
                                            </p>
                                        </div>
                                    </div>

                                    <div className="col-md-3 col-6 mb-3">
                                        <div className="stat-box p-3 shadow-sm rounded">
                                            <h2
                                                className="fw-bold mb-1"
                                                style={{ color: '#fd7e14' }}
                                            >
                                                25k+
                                            </h2>

                                            <p className="mb-0 fw-semibold text-muted small">
                                                B2B & B2C Campaigns
                                            </p>
                                        </div>
                                    </div>

                                </div>

                            </div>

                        </Col>
                    </Row>
                </Container>
            </section>

            <section className="container overlap-image-section">
                <div className="text-center">
                    <img
                        src={multiChannelOutreach}
                        alt="Hrias Dashboard Preview"
                        className="img-fluid overlap-img"
                    />
                </div>
            </section>

            <section className="container my-5 partner-section">

                <h5 className="text-center partner-heading">
                    Trusted by{" "}
                    <span style={{ color: '#fd7e14' }}>
                        6000+
                    </span>{" "}
                    Industry Leaders
                </h5>

                <div className="d-flex justify-content-center align-items-center flex-wrap gap-4 mt-4">

                    <img
                        src={cTOne}
                        alt="KPMG"
                        className="partner-logo"
                        style={{
                            width: '120px',
                            height: 'auto'
                        }}
                    />

                    <img
                        src={cTTwo}
                        alt="Deloitte"
                        className="partner-logo"
                        style={{
                            width: '130px',
                            height: 'auto'
                        }}
                    />

                    <img
                        src={cTThree}
                        alt="Berkshire"
                        className="partner-logo"
                    />

                    <img
                        src={cTFour}
                        alt="Google"
                        className="partner-logo"
                    />

                    <img
                        src={cTFive}
                        alt="PwC"
                        className="partner-logo"
                    />

                    <img
                        src={cTSix}
                        alt="Microsoft"
                        className="partner-logo"
                    />

                </div>

            </section>

            <section
                id="client-testimonials"
                className="container my-5"
            >

                <div className="row align-items-center">

                    <div className="col-md-6 position-relative text-center">

                        <img
                            src={marketing2}
                            alt="Case Study Thumbnail"
                            className="rounded shadow"
                            style={{
                                maxWidth: "60%",
                                height: "auto"
                            }}
                        />

                        <div
                            onClick={openVideoPopup}
                            style={{
                                position: "absolute",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                background: "rgba(0,0,0,0.5)",
                                width: "80px",
                                height: "80px",
                                borderRadius: "50%",
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                cursor: "pointer",
                                transition: "0.3s"
                            }}
                            onMouseOver={(e) =>
                                (e.currentTarget.style.background =
                                    "rgba(0,0,0,0.7)")
                            }
                            onMouseOut={(e) =>
                                (e.currentTarget.style.background =
                                    "rgba(0,0,0,0.5)")
                            }
                        >
                            <FaPlay
                                style={{
                                    fontSize: "32px",
                                    color: "#fff"
                                }}
                            />
                        </div>

                    </div>

                    <div className="col-md-6 mt-4 mt-md-0">

                        <p
                            className="fw-bold text-center"
                            style={{
                                color: "#222",
                                fontSize: "40px",
                                fontWeight: "800",
                                lineHeight: "1.2",
                                marginBottom: "20px"
                            }}
                        >
                            Over{" "}
                            <span style={{ color: "#FF9800" }}>
                                1000+
                            </span>{" "}
                            Partners Trusted{" "}
                            <span style={{ color: "#134373" }}>
                                Peregrinee
                            </span>
                        </p>

                        <h2
                            className="fw-bold"
                            style={{
                                lineHeight: "1.3"
                            }}
                        >
                            <span style={{ color: "#0d6efd" }}>
                                Nexora Technologies
                            </span>{" "}
                            Generates{" "}
                            <span style={{ color: "#0d6efd" }}>
                                $3.8M+
                            </span>{" "}
                            in Sales Pipeline, Books{" "}
                            <span style={{ color: "#0d6efd" }}>
                                165+
                            </span>{" "}
                            Qualified Meetings, and Achieves{" "}
                            <span style={{ color: "#0d6efd" }}>
                                37%+
                            </span>{" "}
                            Response Rate with{" "}
                            <span style={{ color: "#0d6efd" }}>
                                Peregrinee
                            </span>
                        </h2>

                        <button
                            onClick={openVideoPopup}
                            className="btn btn-primary mt-4"
                            style={{
                                backgroundColor: "#134373",
                                borderRadius: "25px",
                                border: "none",
                                padding: "12px 28px",
                                fontWeight: "600"
                            }}
                            onMouseOver={(e) =>
                                (e.target.style.backgroundColor = "#5197dc")
                            }
                            onMouseOut={(e) =>
                                (e.target.style.backgroundColor = "#134373")
                            }
                        >
                            Watch Case Study
                        </button>

                    </div>

                </div>

                <style>{`
                    .video-popup-close {
                        color: white !important;
                        font-size: 22px !important;
                        position: absolute !important;
                        top: 10px !important;
                        right: 12px !important;
                    }

                    .video-popup-style {
                        border-radius: 12px !important;
                    }
                `}</style>

            </section>

            <section
                id="case-studies"
                className="container my-5"
            >

                <h5 className="text-center partner-heading">
                    Our Case{" "}
                    <span style={{ color: '#fd7e14' }}>
                        Studies
                    </span>
                </h5>

            </section>

            <motion.section
                className="container my-5"
                whileHover={{
                    y: -5,
                    scale: 1.01,
                    boxShadow:
                        "0 20px 40px rgba(13, 110, 253, 0.15)"
                }}
                transition={{
                    duration: 0.3
                }}
                style={{
                    background: "#EEF6FF",
                    border: "2px solid #0D6EFD",
                    borderRadius: "24px",
                    padding: "50px",
                    boxShadow:
                        "0 10px 30px rgba(0,0,0,0.25)"
                }}
            >

                <AnimatePresence mode="wait">

                    <motion.div
                        key={currentSection}
                        className="row g-4 align-items-stretch"
                        initial={{
                            opacity: 0,
                            x: 40
                        }}
                        animate={{
                            opacity: 1,
                            x: 0
                        }}
                        exit={{
                            opacity: 0,
                            x: -40
                        }}
                        transition={{
                            duration: 0.45,
                            ease: "easeInOut"
                        }}
                    >

                        <div className="col-lg-6">

                            <motion.div
                                whileHover={{
                                    y: -5,
                                    scale: 1.02
                                }}
                                transition={{
                                    duration: 0.3
                                }}
                                style={{
                                    background: "#F8FBFF",
                                    border: "2px solid #0D6EFD",
                                    borderRadius: "20px",
                                    padding: "24px",
                                    boxShadow:
                                        "0 10px 25px rgba(0,0,0,0.12)",
                                    height: "100%"
                                }}
                            >

                                <motion.h2
                                    key={
                                        sections[currentSection].title
                                    }
                                    initial={{
                                        opacity: 0,
                                        y: 15
                                    }}
                                    animate={{
                                        opacity: 1,
                                        y: 0
                                    }}
                                    transition={{
                                        duration: 0.4
                                    }}
                                    style={{
                                        fontFamily:
                                            "Poppins, sans-serif",
                                        fontSize: "2.5rem",
                                        fontWeight: "700",
                                        color: "#1A1A1A",
                                        marginBottom: "10px",
                                        lineHeight: "1.2"
                                    }}
                                >
                                    {
                                        sections[currentSection]
                                            .title
                                    }
                                </motion.h2>

                                <p
                                    style={{
                                        fontFamily:
                                            "Poppins, sans-serif",
                                        fontSize: "1.2rem",
                                        color: "#666",
                                        lineHeight: "1.65",
                                        marginBottom: "18px",
                                        fontWeight: "400"
                                    }}
                                >
                                    {
                                        sections[currentSection]
                                            .description
                                    }
                                </p>

                                <div className="row g-2 align-items-stretch">

                                    <div className="col-md-6 d-flex">

                                        <motion.div
                                            whileHover={{
                                                scale: 1.03
                                            }}
                                            style={{
                                                background:
                                                    "linear-gradient(135deg, #EAF4FF 0%, #D6E9FF 100%)",
                                                border:
                                                    "2px solid #0D6EFD",
                                                borderRadius: "16px",
                                                padding: "16px",
                                                boxShadow:
                                                    "0 8px 20px rgba(0,0,0,0.08)",
                                                width: "100%",
                                                height: "100%"
                                            }}
                                        >

                                            <h5
                                                style={{
                                                    fontFamily:
                                                        "Poppins, sans-serif",
                                                    fontSize: "1rem",
                                                    fontWeight: "600",
                                                    marginBottom: "6px"
                                                }}
                                            >
                                                {
                                                    sections[
                                                        currentSection
                                                    ]
                                                        .feature1Title
                                                }
                                            </h5>

                                            <p
                                                style={{
                                                    fontFamily:
                                                        "Poppins, sans-serif",
                                                    fontSize:
                                                        "0.88rem",
                                                    lineHeight:
                                                        "1.5",
                                                    marginBottom: 0,
                                                    color: "#555"
                                                }}
                                            >
                                                {
                                                    sections[
                                                        currentSection
                                                    ]
                                                        .feature1Desc
                                                }
                                            </p>

                                        </motion.div>

                                    </div>

                                    <div className="col-md-6 d-flex">

                                        <motion.div
                                            whileHover={{
                                                scale: 1.03
                                            }}
                                            style={{
                                                background:
                                                    "linear-gradient(135deg, #FFF3E8 0%, #FFE0C2 100%)",
                                                border:
                                                    "2px solid #FD7E14",
                                                borderRadius: "16px",
                                                padding: "16px",
                                                boxShadow:
                                                    "0 8px 20px rgba(0,0,0,0.08)",
                                                width: "100%",
                                                height: "100%"
                                            }}
                                        >

                                            <h5
                                                style={{
                                                    fontFamily:
                                                        "Poppins, sans-serif",
                                                    fontSize: "1rem",
                                                    fontWeight: "600",
                                                    marginBottom: "6px"
                                                }}
                                            >
                                                {
                                                    sections[
                                                        currentSection
                                                    ]
                                                        .feature2Title
                                                }
                                            </h5>

                                            <p
                                                style={{
                                                    fontFamily:
                                                        "Poppins, sans-serif",
                                                    fontSize:
                                                        "0.88rem",
                                                    lineHeight:
                                                        "1.5",
                                                    marginBottom: 0,
                                                    color: "#555"
                                                }}
                                            >
                                                {
                                                    sections[
                                                        currentSection
                                                    ]
                                                        .feature2Desc
                                                }
                                            </p>

                                        </motion.div>

                                    </div>

                                </div>

                                <div
                                    className="mt-3"
                                    style={{
                                        display: "flex",
                                        gap: "12px",
                                        width: "100%",
                                    }}
                                >

                                    <button
                                        onClick={handleViewMore}
                                        style={{
                                            flex: 1,
                                            minWidth: 0,
                                            background: "#0D6EFD",
                                            color: "#fff",
                                            border: "none",
                                            padding: "12px 16px",
                                            borderRadius: "12px",
                                            fontFamily:
                                                "Poppins, sans-serif",
                                            fontWeight: "600",
                                            fontSize: "15px",
                                            cursor: "pointer",
                                        }}
                                    >
                                        View More
                                    </button>

                                    <button
                                        onClick={() =>
                                            navigate(
                                                "/contact-us"
                                            )
                                        }
                                        style={{
                                            flex: 1,
                                            minWidth: 0,
                                            background:
                                                "transparent",
                                            color: "#0D6EFD",
                                            border:
                                                "2px solid #0D6EFD",
                                            padding:
                                                "12px 16px",
                                            borderRadius:
                                                "12px",
                                            fontFamily:
                                                "Poppins, sans-serif",
                                            fontWeight: "600",
                                            fontSize: "15px",
                                            cursor: "pointer",
                                            whiteSpace:
                                                "nowrap",
                                        }}
                                    >
                                        Book a Call
                                    </button>

                                </div>

                            </motion.div>

                        </div>

                        <div className="col-lg-6 d-flex">

                            <motion.div
                                whileHover={{
                                    y: -5,
                                    scale: 1.02
                                }}
                                transition={{
                                    duration: 0.3
                                }}
                                style={{
                                    background: "#F8FBFF",
                                    border: "2px solid #0D6EFD",
                                    borderRadius: "20px",
                                    padding: "20px",
                                    boxShadow:
                                        "0 10px 25px rgba(0,0,0,0.12)",
                                    height: "100%",
                                    width: "100%",
                                    display: "flex"
                                }}
                            >

                                <motion.img
                                    key={
                                        sections[currentSection]
                                            .image
                                    }
                                    src={
                                        sections[currentSection]
                                            .image
                                    }
                                    initial={{
                                        opacity: 0,
                                        scale: 1.05
                                    }}
                                    animate={{
                                        opacity: 1,
                                        scale: 1
                                    }}
                                    transition={{
                                        duration: 0.5
                                    }}
                                    alt="Lead Generation"
                                    style={{
                                        width: "100%",
                                        height: "100%",
                                        borderRadius: "16px",
                                        objectFit: "cover"
                                    }}
                                />

                            </motion.div>

                        </div>

                    </motion.div>

                </AnimatePresence>

                <div
                    className="d-flex justify-content-center align-items-center gap-3 mt-4"
                >

                    <motion.button
                        whileHover={{
                            scale: 1.1
                        }}
                        whileTap={{
                            scale: 0.95
                        }}
                        onClick={() =>
                            setCurrentSection(
                                currentSection === 0
                                    ? sections.length - 1
                                    : currentSection - 1
                            )
                        }
                        style={{
                            width: "55px",
                            height: "55px",
                            borderRadius: "50%",
                            border:
                                "2px solid #0D6EFD",
                            background: "#FFFFFF",
                            color: "#0D6EFD",
                            boxShadow:
                                "0 6px 15px rgba(0,0,0,0.1)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <FaArrowLeft />
                    </motion.button>

                    <motion.button
                        whileHover={{
                            scale: 1.1
                        }}
                        whileTap={{
                            scale: 0.95
                        }}
                        onClick={() =>
                            setCurrentSection(
                                currentSection ===
                                    sections.length - 1
                                    ? 0
                                    : currentSection + 1
                            )
                        }
                        style={{
                            width: "55px",
                            height: "55px",
                            borderRadius: "50%",
                            border:
                                "2px solid #0D6EFD",
                            background: "#0D6EFD",
                            color: "#FFFFFF",
                            boxShadow:
                                "0 6px 15px rgba(0,0,0,0.1)",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center"
                        }}
                    >
                        <FaArrowRight />
                    </motion.button>

                </div>

            </motion.section>

            <section className="container my-5 client-review-section">

                <div className="row align-items-center">

                    <div className="col-12 col-md-12">

                        <p className="client-review">
                            “Peregrinee completely changed how we approach outbound. Instead of chasing leads, we now have qualified meetings consistently landing in our calendar. Their team handles everything — from targeting to conversations — so we can focus purely on closing. It’s the first time outbound has actually felt predictable for us.”
                        </p>

                        <h3 className="client-name">
                            Dan M.
                        </h3>

                        <p className="client-position">
                            Agency Founder
                        </p>

                    </div>

                </div>

            </section>

            <section className="curved-divider"></section>

            <section className="light-blue-section py-5">

                <div className="container">

                    <h2 className="text-center fw-bold mb-3 mt-5">
                        What We Do
                    </h2>

                    <div className="text-center mb-4">

                        <button
                            className="btn btn-primary contact-btn"
                            onClick={() =>
                                navigate("/contact-us")
                            }
                        >
                            Contact Sales
                        </button>

                    </div>

                    <div className="info-box d-flex flex-column flex-md-row align-items-center mb-5">

                        <div className="info-img col-md-6 p-3">

                            <img
                                src={prospects}
                                alt="Client 1"
                                className="img-fluid rounded bg-white p-3 shadow-sm"
                            />

                        </div>

                        <div className="info-content col-md-6 p-4 text-md-start">

                            <h4 className="fw-bold mb-3">
                                Define Your Ideal Customers with Precision
                            </h4>

                            <p
                                className="text-muted fw-semibold mb-3"
                                style={{
                                    fontFamily:
                                        'Poppins, sans-serif',
                                    lineHeight: '1.7'
                                }}
                            >
                                We don’t guess your audience — we define it with clarity. Through a deep Ideal Customer Profile (ICP) analysis, we identify exactly who you should be targeting.
                            </p>

                            <p
                                className="text-muted fw-semibold mb-4"
                                style={{
                                    fontFamily:
                                        'Poppins, sans-serif',
                                    lineHeight: '1.7'
                                }}
                            >
                                Using{" "}
                                <span style={{
                                    fontWeight: "bold"
                                }}>
                                    industry, role, and intent-based targeting
                                </span>
                                , we uncover high-converting segments before any outreach begins — ensuring every conversation starts with the right prospect.
                            </p>

                            <button
                                className="btn btn-primary px-4 py-2"
                                onClick={() =>
                                    navigate("/contact-us")
                                }
                            >
                                Contact Sales
                            </button>

                        </div>

                    </div>

                    <div className="info-box d-flex flex-column flex-md-row-reverse align-items-center mb-5">

                        <div className="info-img col-md-6 p-3">

                            <img
                                src={aiPersonalization}
                                alt="AI Personalization"
                                className="img-fluid rounded bg-white p-3 shadow-sm"
                            />

                        </div>

                        <div className="info-content col-md-6 p-4 text-md-start">

                            <h4 className="fw-bold mb-3">
                                Positioning & Messaging That Actually Gets Replies
                            </h4>

                            <p
                                className="text-muted fw-semibold mb-3"
                                style={{
                                    fontFamily:
                                        'Poppins, sans-serif',
                                    lineHeight: '1.7'
                                }}
                            >
                                Most outbound fails because it sounds like everyone else. We craft messaging that cuts through the noise and speaks directly to your prospect’s real pain points.
                            </p>

                            <p
                                className="text-muted fw-semibold mb-4"
                                style={{
                                    fontFamily:
                                        'Poppins, sans-serif',
                                    lineHeight: '1.7'
                                }}
                            >
                                From{" "}
                                <span style={{
                                    fontWeight: "bold"
                                }}>
                                    offer positioning
                                </span>{" "}
                                to{" "}
                                <span style={{
                                    fontWeight: "bold"
                                }}>
                                    personalized cold emails & LinkedIn scripts
                                </span>
                                , we test multiple angles and continuously optimize — ensuring your outreach consistently drives replies and meaningful conversations.
                            </p>

                            <button
                                className="btn btn-primary px-4 py-2"
                                onClick={() =>
                                    navigate("/contact-us")
                                }
                            >
                                Contact Sales
                            </button>

                        </div>

                    </div>

                    <div className="info-box d-flex flex-column flex-md-row align-items-center mb-5">

                        <div className="info-img col-md-6 p-3">

                            <img
                                src={multiChannel}
                                alt="Multi-Channel Automation"
                                className="img-fluid rounded bg-white p-3 shadow-sm"
                            />

                        </div>

                        <div className="info-content col-md-6 p-4 text-md-start">

                            <h4 className="fw-bold mb-3">
                                Multi-Channel Outbound That Reaches Prospects Where They Are
                            </h4>

                            <p
                                className="text-muted fw-semibold mb-3"
                                style={{
                                    fontFamily:
                                        'Poppins, sans-serif',
                                    lineHeight: '1.7'
                                }}
                            >
                                Your prospects don’t live on one platform — so neither do we. We execute outbound across multiple channels to maximize reach, visibility, and response rates.
                            </p>

                            <p
                                className="text-muted fw-semibold mb-4"
                                style={{
                                    fontFamily:
                                        'Poppins, sans-serif',
                                    lineHeight: '1.7'
                                }}
                            >
                                From{" "}
                                <span style={{
                                    fontWeight: "bold"
                                }}>
                                    LinkedIn outreach & conversation handling
                                </span>{" "}
                                to{" "}
                                <span style={{
                                    fontWeight: "bold"
                                }}>
                                    high-deliverability cold email campaigns
                                </span>
                                , we create coordinated touchpoints across channels — ensuring your message reaches the right prospect at the right time.
                            </p>

                            <button
                                className="btn btn-primary px-4 py-2"
                                onClick={() =>
                                    navigate("/contact-us")
                                }
                            >
                                Contact Sales
                            </button>

                        </div>

                    </div>

                    <div className="info-box d-flex flex-column flex-md-row-reverse align-items-center mb-5">

                        <div className="info-img col-md-6 p-3">

                            <img
                                src={notSpam}
                                alt="Email Deliverability"
                                className="img-fluid rounded bg-white p-3 shadow-sm"
                            />

                        </div>

                        <div className="info-content col-md-6 p-4 text-md-start">

                            <h4 className="fw-bold mb-3">
                                Lead Sourcing & Qualification That Prioritizes Quality Over Volume
                            </h4>

                            <p
                                className="text-muted fw-semibold mb-3"
                                style={{
                                    fontFamily:
                                        'Poppins, sans-serif',
                                    lineHeight: '1.7'
                                }}
                            >
                                No scraped junk. No irrelevant contacts. We focus only on prospects who actually fit your business and show real potential or intent.
                            </p>

                            <p
                                className="text-muted fw-semibold mb-4"
                                style={{
                                    fontFamily:
                                        'Poppins, sans-serif',
                                    lineHeight: '1.7'
                                }}
                            >
                                Using{" "}
                                <span style={{
                                    fontWeight: "bold"
                                }}>
                                    verified prospect data
                                </span>
                                , combined with{" "}
                                <span style={{
                                    fontWeight: "bold"
                                }}>
                                    manual + AI-driven research
                                </span>
                                , we ensure every lead is pre-qualified before a meeting is ever booked — so your time is spent only on high-value conversations.
                            </p>

                            <button
                                className="btn btn-primary px-4 py-2"
                                onClick={() =>
                                    navigate("/contact-us")
                                }
                            >
                                Contact Sales
                            </button>

                        </div>

                    </div>

                    <div className="info-box d-flex flex-column flex-md-row align-items-center mb-5">

                        <div className="info-img col-md-6 p-3">

                            <img
                                src={intentSignal}
                                alt="Intent Signals"
                                className="img-fluid rounded bg-white p-3 shadow-sm"
                            />

                        </div>

                        <div className="info-content col-md-6 p-4 text-md-start">

                            <h4 className="fw-bold mb-3">
                                Inbox & Conversation Management That Drives Real Opportunities
                            </h4>

                            <p
                                className="text-muted fw-semibold mb-3"
                                style={{
                                    fontFamily:
                                        'Poppins, sans-serif',
                                    lineHeight: '1.7'
                                }}
                            >
                                We don’t just send messages — we manage the entire conversation flow. Every reply is handled strategically to move prospects closer to a qualified meeting.
                            </p>

                            <p
                                className="text-muted fw-semibold mb-4"
                                style={{
                                    fontFamily:
                                        'Poppins, sans-serif',
                                    lineHeight: '1.7'
                                }}
                            >
                                From{" "}
                                <span style={{
                                    fontWeight: "bold"
                                }}>
                                    reply handling across channels
                                </span>{" "}
                                to{" "}
                                <span style={{
                                    fontWeight: "bold"
                                }}>
                                    objection handling & nurturing
                                </span>
                                , we ensure meaningful conversations while filtering out low-quality prospects — so you only engage when it truly matters.
                            </p>

                            <button
                                className="btn btn-primary px-4 py-2"
                                onClick={() =>
                                    navigate("/contact-us")
                                }
                            >
                                Contact Sales
                            </button>

                        </div>

                    </div>

                    <div className="info-box d-flex flex-column flex-md-row-reverse align-items-center mb-5">

                        <div className="info-img col-md-6 p-3">

                            <img
                                src={customDev}
                                alt="Custom Development"
                                className="img-fluid rounded bg-white p-3 shadow-sm"
                            />

                        </div>

                        <div className="info-content col-md-6 p-4 text-md-start">

                            <h4 className="fw-bold mb-3">
                                Done-for-You Meeting Booking That Fills Your Calendar
                            </h4>

                            <p
                                className="text-muted fw-semibold mb-3"
                                style={{
                                    fontFamily:
                                        'Poppins, sans-serif',
                                    lineHeight: '1.7'
                                }}
                            >
                                Your calendar fills up — without your involvement. We handle the entire booking process so you can focus only on closing high-value opportunities.
                            </p>

                            <p
                                className="text-muted fw-semibold mb-4"
                                style={{
                                    fontFamily:
                                        'Poppins, sans-serif',
                                    lineHeight: '1.7'
                                }}
                            >
                                With{" "}
                                <span style={{
                                    fontWeight: "bold"
                                }}>
                                    direct booking into your calendar
                                </span>
                                , only{" "}
                                <span style={{
                                    fontWeight: "bold"
                                }}>
                                    qualified and relevant prospects
                                </span>{" "}
                                are scheduled. We also optimize for{" "}
                                <span style={{
                                    fontWeight: "bold"
                                }}>
                                    show-up rates
                                </span>
                                , ensuring your time is spent on real, productive conversations.
                            </p>

                            <button
                                className="btn btn-primary px-4 py-2"
                                onClick={() =>
                                    navigate("/contact-us")
                                }
                            >
                                Contact Sales
                            </button>

                        </div>

                    </div>

                    <div className="info-box d-flex flex-column flex-md-row align-items-center mb-5">

                        <div className="info-img col-md-6 p-3">

                            <img
                                src={dm6}
                                alt="Reporting and Optimization"
                                className="img-fluid rounded bg-white p-3 shadow-sm"
                            />

                        </div>

                        <div className="info-content col-md-6 p-4 text-md-start">

                            <h4 className="fw-bold mb-3">
                                Reporting & Optimization That Drives Continuous Growth
                            </h4>

                            <p
                                className="text-muted fw-semibold mb-3"
                                style={{
                                    fontFamily:
                                        'Poppins, sans-serif',
                                    lineHeight: '1.7'
                                }}
                            >
                                Clear visibility. Real metrics. No guesswork. We track what actually matters so you always know how your outbound is performing.
                            </p>

                            <p
                                className="text-muted fw-semibold mb-4"
                                style={{
                                    fontFamily:
                                        'Poppins, sans-serif',
                                    lineHeight: '1.7'
                                }}
                            >
                                From{" "}
                                <span style={{
                                    fontWeight: "bold"
                                }}>
                                    campaign performance tracking
                                </span>{" "}
                                to{" "}
                                <span style={{
                                    fontWeight: "bold"
                                }}>
                                    messaging & targeting iterations
                                </span>
                                , we continuously refine your outreach using{" "}
                                <span style={{
                                    fontWeight: "bold"
                                }}>
                                    pipeline-focused insights
                                </span>
                                {" "}— not vanity metrics.
                            </p>

                            <button
                                className="btn btn-primary px-4 py-2"
                                onClick={() =>
                                    navigate("/contact-us")
                                }
                            >
                                Contact Sales
                            </button>

                        </div>

                    </div>

                </div>

            </section>

            <section className="container my-5">

                <h5 className="text-center partner-heading mb-4">
                    What Makes{" "}
                    <span style={{ color: '#fd7e14' }}>
                        Us
                    </span>{" "}
                    Different
                </h5>

                <div className="text-center mb-4">

                    <button
                        className="btn btn-primary contact-btn"
                        onClick={() =>
                            navigate("/contact-us")
                        }
                    >
                        Contact Sales
                    </button>

                </div>

                <div className="row g-4">

                    <div className="col-12 col-md-6">

                        <div className="before-box p-4 h-100">

                            <h5 className="fw-bold text-dark mb-3 d-flex align-items-center">

                                <FaTimesCircle className="me-2 text-danger" />

                                Typical Agencies

                            </h5>

                            <ul className="list-unstyled small mb-0">

                                <li>
                                    <FaTimesCircle className="me-2 text-danger" />
                                    Focus on number of emails sent
                                </li>

                                <li>
                                    <FaTimesCircle className="me-2 text-danger" />
                                    Book unqualified or irrelevant calls
                                </li>

                                <li>
                                    <FaTimesCircle className="me-2 text-danger" />
                                    Use generic templates across clients
                                </li>

                                <li>
                                    <FaTimesCircle className="me-2 text-danger" />
                                    Treat channels separately
                                </li>

                                <li>
                                    <FaTimesCircle className="me-2 text-danger" />
                                    Stop at “meeting booked”
                                </li>

                            </ul>

                        </div>

                    </div>

                    <div className="col-12 col-md-6">

                        <div className="after-box p-4 h-100">

                            <h5 className="fw-bold text-success mb-3 d-flex align-items-center">

                                <FaCheckCircle className="me-2 text-success" />

                                After Peregrinee

                            </h5>

                            <ul className="list-unstyled small mb-0">

                                <li>
                                    <FaCheckCircle className="me-2 text-success" />
                                    Focus on qualified, sales-ready conversations
                                </li>

                                <li>
                                    <FaCheckCircle className="me-2 text-success" />
                                    Filter prospects before they reach you
                                </li>

                                <li>
                                    <FaCheckCircle className="me-2 text-success" />
                                    Build custom messaging per market
                                </li>

                                <li>
                                    <FaCheckCircle className="me-2 text-success" />
                                    Run multi-channel systems, not campaigns
                                </li>

                                <li>
                                    <FaCheckCircle className="me-2 text-success" />
                                    Optimize for pipeline, not just meetings
                                </li>

                            </ul>

                        </div>

                    </div>

                </div>

            </section>

            <section className="container my-5 custom-section-wrapper">

                <button
                    className="scroll-arrow left-arrow"
                    onClick={scrollLeft}
                >
                    <FaLessThan />
                </button>

                <div
                    className="scroll-container"
                    ref={scrollRef}
                >

                    {[
                        {
                            title: "Consistent pipeline growth within weeks",
                            description: "Peregrinee built a complete outbound system for us — from ICP targeting to messaging and execution. Within weeks, we started seeing a steady flow of qualified leads and booked meetings. Their approach is structured, data-driven, and focused on real results.",
                            // name: "Elizabeth Carter",
                            // position: "Business Consultant, James Business Solutions",
                            // img: ct1,
                            rating: "5.0/5.0",
                            link: "https://www.peregrinee.com/digital-marketing"
                        },
                        {
                            title: "High-quality leads, not just volume",
                            description: "Unlike typical agencies, Peregrinee focuses on relevance and intent. The leads we received were decision-makers who actually needed our services. Their lead sourcing and qualification process saved our team a lot of time.",
                            // name: "James Nguyen",
                            // position: "CEO, Quantropi Inc.",
                            // img: ct2,
                            rating: "4.9/5.0",
                            link: "https://www.peregrinee.com/digital-marketing"
                        },
                        {
                            title: "Best outbound and lead generation partner",
                            description: "Peregrinee helped us scale our outreach with personalized messaging and multi-channel campaigns. From LinkedIn to cold email, everything was handled seamlessly, resulting in consistent meetings and real opportunities.",
                            name: "Hazel Montgomery",
                            // position: "Staffing & Recruiting",
                            // img: ct3,
                            rating: "4.8/5.0",
                            link: "https://www.peregrinee.com/digital-marketing"
                        },
                        {
                            title: "From zero outreach to booked meetings",
                            description: "We had no outbound system before working with Peregrinee. They set everything up and started booking qualified calls directly into our calendar. The process is smooth, and the results are consistent.",
                            // name: "Ganesh Pawar",
                            // position: "Google Business Profile",
                            // img: ct4,
                            rating: "5.0/5.0",
                            link: "https://www.peregrinee.com/digital-marketing"
                        }
                    ].map((item, idx) => (

                        <motion.div
                            key={idx}
                            className="col-12 col-md-6 col-lg-4"
                            initial={{
                                opacity: 0,
                                scale: 0.9
                            }}
                            whileInView={{
                                opacity: 1,
                                scale: 1
                            }}
                            viewport={{
                                once: false,
                                amount: 0.4
                            }}
                            transition={{
                                duration: 0.5,
                                ease: "easeOut"
                            }}
                        >

                            <div className="custom-card p-3 h-100">

                                <div className="top-left-content mb-3">

                                    <h5 className="fw-bold">
                                        {item.title}
                                    </h5>

                                    <p>
                                        {item.description}
                                    </p>

                                </div>

                                <div className="d-flex align-items-center gap-3">

                                    {/* <a
                                        href={item.link}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >

                                        <img
                                            src={item.img}
                                            alt={`profile-${idx + 1}`}
                                            className="profile-img"
                                        />

                                    </a> */}

                                    <div className="profile-info">

                                        {/* <div className="profile-name">
                                            {item.name}
                                        </div> */}

                                        <div className="profile-position">
                                            {item.position}
                                        </div>

                                        <div className="profile-rating">
                                            ⭐⭐⭐⭐⭐ {item.rating}
                                        </div>

                                    </div>

                                </div>

                            </div>

                        </motion.div>

                    ))}

                </div>

                <button
                    className="scroll-arrow right-arrow"
                    onClick={scrollRight}
                >
                    <FaGreaterThan />
                </button>

            </section>

            <section className="container my-5">

                <div className="text-center mb-5">

                    <h2 className="fw-bold">
                        How It{" "}
                        <span style={{ color: '#fd7e14' }}>
                            Works
                        </span>
                    </h2>

                    <div className="text-center mt-4">

                        <button
                            className="btn btn-primary contact-btn"
                            onClick={() =>
                                navigate("/contact-us")
                            }
                        >
                            Contact Sales
                        </button>

                    </div>

                </div>

                <div className="row g-4">

                    <div className="col-md-4">

                        <div
                            className="p-4 h-100 rounded-4 shadow-sm"
                            style={{
                                background: '#fff4e6',
                                border:
                                    '2px solid #fd7e14'
                            }}
                        >

                            <h5
                                className="fw-bold mb-3"
                                style={{
                                    color: '#fd7e14'
                                }}
                            >
                                How It Works
                            </h5>

                            <ol
                                className="text-muted fw-semibold"
                                style={{
                                    lineHeight: '1.9',
                                    paddingLeft: '18px'
                                }}
                            >
                                <li>Define ICP & positioning</li>
                                <li>Build outbound system</li>
                                <li>Launch campaigns</li>
                                <li>Handle conversations</li>
                                <li>Book meetings</li>
                            </ol>

                            <p className="fw-bold mt-3 mb-0">
                                You close. We handle the rest.
                            </p>

                        </div>

                    </div>

                    <div className="col-md-4">

                        <div
                            className="p-4 h-100 rounded-4 shadow-sm"
                            style={{
                                background: '#e7f1ff',
                                border:
                                    '2px solid #0d6efd'
                            }}
                        >

                            <h5
                                className="fw-bold mb-3"
                                style={{
                                    color: '#0d6efd'
                                }}
                            >
                                Who This Is For
                            </h5>

                            <ul
                                style={{
                                    lineHeight: '1.9',
                                    listStyle: 'none',
                                    paddingLeft: '0'
                                }}
                            >
                                <li>✓ B2B companies</li>
                                <li>✓ Service providers</li>
                                <li>✓ Founders tired of chasing leads</li>
                                <li>✓ Teams avoiding SDR hiring</li>
                            </ul>

                        </div>

                    </div>

                    <div className="col-md-4">

                        <div
                            className="p-4 h-100 rounded-4 shadow-sm"
                            style={{
                                background: '#f3e8ff',
                                border:
                                    '2px solid #6610f2'
                            }}
                        >

                            <h5
                                className="fw-bold mb-3"
                                style={{
                                    color: '#6610f2'
                                }}
                            >
                                What You Get
                            </h5>

                            <ul
                                style={{
                                    lineHeight: '1.9',
                                    listStyle: 'none',
                                    paddingLeft: '0'
                                }}
                            >
                                <li>✓ Qualified sales meetings</li>
                                <li>✓ Decision-maker conversations</li>
                                <li>✓ Higher close rates</li>
                                <li>✓ Scalable outbound system</li>
                            </ul>

                        </div>

                    </div>

                </div>

            </section>

            <div className="mt-5 d-flex justify-content-center">

                <div
                    className="text-center p-4 rounded-4 shadow-sm"
                    style={{
                        backgroundColor: '#f8f9fa',
                        border:
                            '2px solid #212529',
                        maxWidth: '500px',
                        width: '100%'
                    }}
                >

                    <h5 className="mb-2 fw-bold">
                        Ready to scale your pipeline?
                    </h5>

                    <p className="text-muted mb-3">
                        Let’s build your outbound system and start generating results.
                    </p>

                    <button
                        className="btn btn-primary contact-btn px-4 py-2"
                        onClick={() =>
                            navigate("/contact-us")
                        }
                    >
                        Contact Sales
                    </button>

                </div>

            </div>

            <section
                className="faq-section"
                style={{
                    backgroundImage:
                        `url(${servicebg})`
                }}
            >

                <motion.section
                    className="container my-5"
                    initial={{
                        y: 30,
                        opacity: 0
                    }}
                    whileInView={{
                        y: 0,
                        opacity: 1
                    }}
                    viewport={{
                        once: true,
                        amount: 0.6
                    }}
                    transition={{
                        duration: 0.8,
                        ease: "easeOut"
                    }}
                >

                    <div className="d-flex align-items-center justify-content-center text-center flex-wrap">

                        <div className="px-3 fw-bold responsive-heading">
                            Frequently{" "}
                            <span className="highlight-orange">
                                Asked
                            </span>{" "}
                            Questions
                        </div>

                    </div>

                    <div className="text-center mt-4">

                        <button
                            className="btn btn-primary contact-btn"
                            onClick={() =>
                                navigate("/contact-us")
                            }
                        >
                            Contact Sales
                        </button>

                    </div>

                </motion.section>

                <div className="container my-5">

                    <div className="row g-4">

                        <div className="col-12 col-md-6">

                            <div
                                className="accordion"
                                id="accordionColumn1"
                            >

                                {faqColumn1.map(
                                    (faq, index) => (

                                        <motion.div
                                            variants={fadeInUp}
                                            initial="hidden"
                                            whileInView="visible"
                                            viewport={{
                                                once: false,
                                                amount: 0.3
                                            }}
                                            className="accordion-item shadow mb-3 rounded p-2"
                                            key={index}
                                            style={{
                                                boxShadow:
                                                    '0 4px 8px rgba(0,0,0,0.1)'
                                            }}
                                        >

                                            <h2
                                                className="accordion-header"
                                                id={`heading1-${index}`}
                                            >

                                                <button
                                                    className="accordion-button collapsed fw-bold"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse1-${index}`}
                                                    aria-expanded="true"
                                                    aria-controls={`collapse1-${index}`}
                                                    style={{
                                                        fontWeight:
                                                            '700',
                                                        backgroundColor:
                                                            '#fff',
                                                        whiteSpace:
                                                            'normal',
                                                        wordBreak:
                                                            'break-word',
                                                        overflowWrap:
                                                            'break-word',
                                                    }}
                                                >
                                                    {faq.question}
                                                </button>

                                            </h2>

                                            <div
                                                id={`collapse1-${index}`}
                                                className="accordion-collapse collapse"
                                                aria-labelledby={`heading1-${index}`}
                                                data-bs-parent="#accordionColumn1"
                                            >

                                                <div
                                                    className="accordion-body"
                                                    style={{
                                                        backgroundColor:
                                                            '#fff4e6'
                                                    }}
                                                >
                                                    {faq.answer}
                                                </div>

                                            </div>

                                        </motion.div>

                                    )
                                )}

                            </div>

                        </div>

                        <div className="col-12 col-md-6">

                            <div
                                className="accordion"
                                id="accordionColumn2"
                            >

                                {faqColumn2.map(
                                    (faq, index) => (

                                        <motion.div
                                            variants={fadeInUp}
                                            initial="hidden"
                                            whileInView="visible"
                                            viewport={{
                                                once: false,
                                                amount: 0.3
                                            }}
                                            className="accordion-item shadow mb-3 rounded p-2"
                                            key={index}
                                            style={{
                                                boxShadow:
                                                    '0 4px 8px rgba(0,0,0,0.1)'
                                            }}
                                        >

                                            <h2
                                                className="accordion-header"
                                                id={`heading2-${index}`}
                                            >

                                                <button
                                                    className="accordion-button collapsed fw-bold"
                                                    type="button"
                                                    data-bs-toggle="collapse"
                                                    data-bs-target={`#collapse2-${index}`}
                                                    aria-expanded="true"
                                                    aria-controls={`collapse2-${index}`}
                                                    style={{
                                                        fontWeight:
                                                            '700',
                                                        backgroundColor:
                                                            '#fff',
                                                        whiteSpace:
                                                            'normal',
                                                        wordBreak:
                                                            'break-word',
                                                        overflowWrap:
                                                            'break-word',
                                                    }}
                                                >
                                                    {faq.question}
                                                </button>

                                            </h2>

                                            <div
                                                id={`collapse2-${index}`}
                                                className="accordion-collapse collapse"
                                                aria-labelledby={`heading2-${index}`}
                                                data-bs-parent="#accordionColumn2"
                                            >

                                                <div
                                                    className="accordion-body"
                                                    style={{
                                                        backgroundColor:
                                                            '#fff4e6'
                                                    }}
                                                >
                                                    {faq.answer}
                                                </div>

                                            </div>

                                        </motion.div>

                                    )
                                )}

                            </div>

                        </div>

                    </div>

                </div>

            </section>

        </>
    );
}

export default ProductPage;